/**
 * ActivityIcon - Icone selon le type d'evenement
 *
 * Types supportes:
 * - view: consultation
 * - create: creation
 * - update: modification
 * - delete: suppression
 * - action: action workflow (submit, approve, reject...)
 * - page_view: visite de page
 */
import React from 'react';

const ICON_CONFIG = {
  view: { emoji: '👁️', color: '#2196f3', label: 'Consultation' },
  create: { emoji: '➕', color: '#4caf50', label: 'Creation' },
  update: { emoji: '✏️', color: '#ff9800', label: 'Modification' },
  delete: { emoji: '🗑️', color: '#f44336', label: 'Suppression' },
  action: { emoji: '⚡', color: '#9c27b0', label: 'Action' },
  page_view: { emoji: '📄', color: '#607d8b', label: 'Page' }
};

const ActivityIcon = ({ type, size = 'medium', showLabel = false }) => {
  const config = ICON_CONFIG[type] || { emoji: '📌', color: '#9e9e9e', label: type };

  const sizeMap = {
    small: { icon: 16, wrapper: 28 },
    medium: { icon: 20, wrapper: 36 },
    large: { icon: 24, wrapper: 44 }
  };

  const sizes = sizeMap[size] || sizeMap.medium;

  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px'
    }}>
      <div style={{
        width: sizes.wrapper,
        height: sizes.wrapper,
        borderRadius: '50%',
        background: `${config.color}15`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: sizes.icon,
        flexShrink: 0
      }}>
        {config.emoji}
      </div>
      {showLabel && (
        <span style={{
          fontSize: '12px',
          color: config.color,
          fontWeight: 500
        }}>
          {config.label}
        </span>
      )}
    </div>
  );
};

export default ActivityIcon;
